import { createAction, props } from '@ngrx/store';
import { MappedHttpErrorResponse } from '@adnova/jf-ng-components';
import { AnnouncementDetailDTO, ProblemDTO } from '../../openapi/shell-service-openapi';

/**
 * Actions für Announcement-Detail-Entities.
 */
export class AnnouncementDetailEntitiesActions {
  private static readonly prefix = '[Announcement Detail Entities]';

  /** Lädt die Detail-Daten eines Announcements. */
  static loadDetail = createAction(
    `${this.prefix} Load Detail`,
    props<{ id: string }>(),
  );

  /** Detail-Daten erfolgreich geladen. */
  static loadDetailSuccess = createAction(
    `${this.prefix} Load Detail Success`,
    props<{ detail: AnnouncementDetailDTO }>(),
  );

  /** Fehler beim Laden der Detail-Daten. */
  static loadDetailFailure = createAction(
    `${this.prefix} Load Detail Failure`,
    props<{ error: MappedHttpErrorResponse<ProblemDTO> }>(),
  );

  /** Entfernt ein Detail aus dem Store. */
  static clearDetail = createAction(
    `${this.prefix} Clear Detail`,
    props<{ id: string }>(),
  );

  /** Entfernt alle Details aus dem Store. */
  static clearAll = createAction(
    `${this.prefix} Clear All`,
  );
}
